import styled from 'styled-components';

export const BodyText = styled.div`
  font-size: 16px;
`;

export const Title3 = styled.div`
  font-size: 20px;
`;
